import OverlayLoader from 'components/ui/OverlayLoader'
import useUserRole from 'hooks/useUserRole'
import React, { useEffect } from 'react'
import { useAuth } from 'react-oidc-context'
import { Outlet } from 'react-router-dom'
import { COGNITO_LOGOUT_URI } from 'config'

export default function AuthGuard() {
  const auth = useAuth()
  const { isAdmin, isAdminCourseEditor, isGpsEditor } = useUserRole()

  useEffect(() => {
    //if user is not authenticated it gets redirected back to cognito
    if (!auth.isLoading && !auth.isAuthenticated && !auth.activeNavigator) {
      auth.signinRedirect()
    }
  }, [auth.isLoading, auth.isAuthenticated, auth.activeNavigator])

  if (auth.isLoading || !auth.isAuthenticated) {
    return <OverlayLoader visible={true} />
  }
  if (!isAdmin && !isAdminCourseEditor && !isGpsEditor) {
    auth.removeUser()
    auth.clearStaleState()
    auth.signoutRedirect({
      post_logout_redirect_uri: undefined,
      extraQueryParams: {
        logout_uri: COGNITO_LOGOUT_URI || '',
      },
    })
  }

  return <Outlet />
}
